import { render, staticRenderFns } from "./VOrderShipping.vue?vue&type=template&id=058a6794&scoped=true"
import script from "./VOrderShipping.vue?vue&type=script&lang=ts"
export * from "./VOrderShipping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a6794",
  null
  
)

export default component.exports